import { render, staticRenderFns } from "./CategoryItem.vue?vue&type=template&id=ac92607e&"
import script from "./CategoryItem.vue?vue&type=script&lang=js&"
export * from "./CategoryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Projekte/woerner-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac92607e')) {
      api.createRecord('ac92607e', component.options)
    } else {
      api.reload('ac92607e', component.options)
    }
    module.hot.accept("./CategoryItem.vue?vue&type=template&id=ac92607e&", function () {
      api.rerender('ac92607e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/woerner/CategoryItem.vue"
export default component.exports